import React, { useState } from 'react';
import { Container, Col, Row } from "react-bootstrap";
import axios from 'axios';

import contactImg from '../assets/img/contact-img.jpeg';

export const ContactForm = () => {
    const [status, setStatus] = useState({});
    const [buttonText, setButtonText] = useState('Send');

    const formInitialDetails = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: '',
    }

    const [inputs, setInputs] = useState(formInitialDetails);

    const handleServerResponse = (ok, msg) => {
        if (ok) {
            setStatus({ success: true, message: msg});
            setInputs(formInitialDetails);
        } else {
            setStatus({
                info: { error: true, msg: msg },
            });
        }

        setButtonText('Send');
    };

    const handleOnChange = (e) => {
        e.persist();
        setInputs((prev) => ({  
            ...prev,
            [e.target.id]: e.target.value,
        }));
    };

    const isValidName = (name) => /^[A-Za-zÁáÉéÍíÓóÚúÑñ\s]+$/.test(name);
    const isValidPhone = (phone) => /^\d+$/.test(phone);
    const emptyFields = Object.values(inputs).some(value => value === '');

    const handleOnSubmit = (e) => {
        e.preventDefault();
        setStatus((prevStatus) => ({ ...prevStatus, submitting: true }));

        if (emptyFields) {
            setStatus({ success: false, message: 'Please fill in all fields.' });
        } else if (!isValidName(inputs.firstName) || !isValidName(inputs.lastName) || !isValidName(inputs.message)){
            setStatus({ success: false, message: 'Name , LastName y Message should only contain letters and spaces.' });
        } else if (!isValidPhone(inputs.phone)) {
            setStatus({ success: false, message: 'Phone should only contain numbers.' });
        } else {
            
            setButtonText("Checking Data ...");
            axios({
                method: 'POST',
                url: 'https://formspree.io/f/mzbnbblo',
                data: inputs,
            })
                .then((response) => {
                    handleServerResponse(
                        true,
                        'Message sent successfully',
                    );
                })
                .catch((error) => {
                    handleServerResponse(false, error.response.data.error);
                });
        }
    };

    return (
        <section className="contact" id="connect">
            <Container>
                <Row className="aligh-item-center">
                    <Col md={6} className="d-none d-md-block">
                        <img src={contactImg} alt="Contact US" />
                    </Col>

                    <Col md={6}>
                        <h2>Let's Stay in Touch</h2>

                        <form onSubmit={handleOnSubmit}>
                            <Row>
                                <Col sm={6} className="px-1">
                                    <input
                                        id="firstName"
                                        name="firstName"
                                        autoComplete="off"
                                        type="text"
                                        maxLength={10}
                                        value={inputs.firstName}
                                        placeholder="First Name"
                                        onChange={handleOnChange}
                                    />
                                </Col>

                                <Col sm={6} className="px-1">
                                    <input
                                        id="lastName"
                                        name="lastName"
                                        autoComplete="off"
                                        type="text"
                                        maxLength={10}
                                        value={inputs.lastName}
                                        placeholder="Last Name"
                                        onChange={handleOnChange}
                                    />
                                </Col>

                                <Col sm={6} className="px-1">
                                    <input
                                        id="email"
                                        name="_replyto"
                                        autoComplete="off"
                                        type="email"
                                        maxLength={35}
                                        value={inputs.email}
                                        placeholder="Email"
                                        onChange={handleOnChange}
                                    />
                                </Col>

                                <Col sm={6} className="px-1">
                                    <input
                                        id="phone"
                                        name="phone"
                                        autoComplete="off"
                                        type="tel"
                                        value={inputs.phone}
                                        placeholder="Phone"
                                        onChange={handleOnChange}
                                    />
                                </Col>

                                    <textarea
                                        id="message"
                                        name="message"
                                        type="text"
                                        maxLength={100}
                                        value={inputs.message}
                                        placeholder="Message"
                                        onChange={handleOnChange}
                                    />

                                    <button type="submit" disabled={status.submitting} className="ov-btn-slide-left">
                                        {buttonText}
                                    </button>

                                    {status.message &&
                                        <Col>
                                            <p className={status.success === false
                                                ? "danger"
                                                : "success"}>
                                                {status.message}
                                            </p>
                                        </Col>
                                    }
                            </Row>
                        </form>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};
